export default ({
  isFirstLoading: true,
  fetching: {
    listFormModels: false,
    listDrafts: false,
    createFormEmpty: false,
    createDraft: false,
    getCategories: false,
    saveSections: false,
    listFormModelsDeleted: false,
    updateStatusFormModelById: false,
    listDraftsDeleted: false,
    updateStatusDraftById: false,
  },
  tabSelected: '0',
  sidebar:{
    allFormModels: true,
    categoryUndefined: false,
    categorySelected: false,
  },
  api: {
    listFormModels: [],
    listFormModelsGlobals: [],
    listFormModelsDeleted: [],
    listDrafts: [],
    listDraftsDeleted: [],
    categoriesForms: [],
    categoriesAllForms: [],
    categorySelected: {},
    authors: [],
    favorites: {
      formModels: []
    },
    filter:{
      forms: [],
      isFilter: false,
    }
  }
});